import { render, staticRenderFns } from "./show_card.vue?vue&type=template&id=2ee988f4&lang=pug&"
import script from "./show_card.vue?vue&type=script&lang=js&"
export * from "./show_card.vue?vue&type=script&lang=js&"
import style0 from "./show_card.vue?vue&type=style&index=0&id=2ee988f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports